import { Component } from 'react';

/** Components */
import Keypad from './Keypad';
import LatexKeypadButton from './LatexKeypadButton';
import KeypadButton from './KeypadButton';
import MathModeKey from './MathModeKey';

class Physics extends Component {
  render() {
    return (
      <Keypad className="physics" {...this.props}>
        <div>
          {/* Symbols */}
          <LatexKeypadButton label="x" />
          <LatexKeypadButton label="x^2" value="^2" />
          <LatexKeypadButton label="x^{}" />
          <LatexKeypadButton label="x_{}" />
          <LatexKeypadButton label="\sqrt{}" />
          {/* Fractions */}
          <LatexKeypadButton label="\frac{}{}" />
          <LatexKeypadButton label="x\frac{}{}" />
        </div>
        <div>
          <LatexKeypadButton label="y" />
          {}
          <LatexKeypadButton label="({})" />
          <LatexKeypadButton label="[{}]" />
          <LatexKeypadButton label="|{}|" />
          {/* Symbols */}
          <KeypadButton label="&plusmn;" />
          <LatexKeypadButton label="\sqrt[]{}" />
          {/* Greek Alpha */}
          <LatexKeypadButton label="\Omega" />
        </div>
        <div>
          {/* Symbols */}
          <KeypadButton label="&lt;" />
          <KeypadButton label="&gt;" />
          <KeypadButton label="&ge;" />
          <KeypadButton label="&le;" />
          <KeypadButton label="&#8776;" />
          <KeypadButton label="&ne;" />
          <LatexKeypadButton label="\Delta" />
        </div>
        <div>
          {/* Geometry & Trigonometry */}
          <KeypadButton label="&pi;" />
          <KeypadButton label="log" />
          <KeypadButton label="cos" />
          <KeypadButton label="sin" />
          <KeypadButton label="tan" />
          <LatexKeypadButton label="\varepsilon" />
          <LatexKeypadButton label="\phi" />
        </div>
        <div>
          {/* Logic */}
          <LatexKeypadButton label="\therefore" />
          <LatexKeypadButton label="\to" />
          <LatexKeypadButton label="\Leftrightarrow" />
          <LatexKeypadButton label="\Rightarrow" />
          {/* Greek Alpha */}
          <LatexKeypadButton label="\lambda" />
          <LatexKeypadButton label="\theta" />
          {/* Symbols */}
          <LatexKeypadButton label="\circ" />
        </div>
        <div>
          {/* Math Roman */}
          <MathModeKey />
        </div>
      </Keypad>
    );
  }
}

export default Physics;
